import React, { useState, useEffect } from 'react';

export const performanceEmitter = {
  listeners: [],
  subscribe(fn) {
    this.listeners.push(fn);
    return () => (this.listeners = this.listeners.filter((l) => l !== fn));
  },
  emit(data) {
    this.listeners.forEach((fn) => fn(data));
  },
};

const PerformanceMonitor = () => {
  const [logs, setLogs] = useState([]);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const unsubscribe = performanceEmitter.subscribe((newLog) => {
      setLogs((prev) => [newLog, ...prev].slice(0, 15));
    });
    return () => unsubscribe();
  }, []);

  // Added clear logs handler
  const clearAllLogs = () => {
    setLogs([]);
  };

  if (!isVisible)
    return (
      <button
        onClick={() => setIsVisible(true)}
        style={styles.showButton}
      >
        📊 Monitor
      </button>
    );

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <span style={{ fontWeight: 'bold' }}>🚀 API PERFORMANCE</span>

        {/* Added buttons wrapper */}
        <div style={styles.headerActions}>
          {/* Added Clear All button */}
          <button onClick={clearAllLogs} style={styles.clearBtn}>
            Clear All
          </button>

          <button
            onClick={() => setIsVisible(false)}
            style={styles.closeBtn}
          >
            ×
          </button>
        </div>
      </div>

      <div style={styles.logList}>
        {logs.map((log, index) => (
          <div key={index} style={styles.logEntry}>
            <div style={styles.topRow}>
              <span style={styles.reqName}>{log.label}</span>

              <span>
                <span style={styles.totalTime}>
                  {log.totalTime}ms
                </span>

                <span
                  style={{
                    ...styles.statusBadge,
                    backgroundColor:
                      log.status >= 400
                        ? '#cf6679'
                        : '#03dac6',
                  }}
                >
                  {log.status}
                </span>
              </span>
            </div>

            <div style={styles.idRow}>
              {log.elementId || 'No ID'}
            </div>

            <div style={styles.breakdownRow}>
              <span>
                PRE: <b>{log.preTime}ms</b>
              </span>

              <span>
                NET:{' '}
                <b style={{ color: '#03dac6' }}>
                  {log.netTime}ms
                </b>
              </span>

              <span>
                POST: <b>{log.postTime}ms</b>
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    width: '420px',
    backgroundColor: '#1e1e1e',
    color: '#fff',
    borderRadius: '6px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
    fontFamily: 'monospace',
    zIndex: 99999,
    border: '1px solid #333',
  },

  header: {
    padding: '8px 12px',
    background: '#2d2d2d',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '11px',
    borderBottom: '1px solid #444',
  },

  // Added
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  // Added
  clearBtn: {
    background: '#444',
    border: '1px solid #666',
    color: '#fff',
    cursor: 'pointer',
    fontSize: '10px',
    padding: '3px 8px',
    borderRadius: '3px',
  },

  closeBtn: {
    background: 'none',
    border: 'none',
    color: '#ff5f56',
    cursor: 'pointer',
    fontSize: '16px',
  },

  showButton: {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    padding: '6px 12px',
    background: '#2d2d2d',
    color: '#fff',
    border: '1px solid #444',
    borderRadius: '4px',
    cursor: 'pointer',
  },

  logList: {
    maxHeight: '450px',
    overflowY: 'auto',
  },

  logEntry: {
    padding: '10px 12px',
    borderBottom: '1px solid #333',
  },

  topRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '4px',
    alignItems: 'center',
  },

  reqName: {
    fontSize: '12px',
    color: '#bb86fc',
    fontWeight: 'bold',
  },

  statusBadge: {
    fontSize: '9px',
    color: '#000',
    padding: '1px 5px',
    borderRadius: '2px',
    fontWeight: 'bold',
  },

  totalTime: {
    fontSize: '11px',
    fontWeight: 'bold',
    color: '#ff4d4d',
    marginRight: '10px',
  },

  idRow: {
    fontSize: '10px',
    color: '#888',
    marginBottom: '8px',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
  },

  breakdownRow: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '9px',
    color: '#aaa',
    background: '#282828',
    padding: '5px',
    borderRadius: '3px',
    border: '1px solid #333',
  },
};

export default PerformanceMonitor;